export default __webpack_public_path__ + "static/media/linux.5a2790cb.png";